import { DocLayout } from './DocLayout';

export default function DocParteneri() {
  return (
    <DocLayout title="Prieteni">
      <h2>Prezentare generală</h2>
      <p>
        Pagina de prieteni permite gestionarea organizațiilor prietene ale programului.
        Prietenii pot fi asociați cu activități ca organizatori și pot primi acces la datele participanților.
      </p>

      <h2>Lista de prieteni</h2>
      <p>Tabelul afișează toți prietenii din sistem. Poți căuta după nume și vezi:</p>
      <ul>
        <li><strong>Logo și nume</strong> — identitatea vizuală a prietenului.</li>
        <li><strong>Denumire legală</strong> — afișată sub numele public.</li>
        <li><strong>Tip organizație</strong> — Instituție publică, Companie privată, ONG sau Grup informal.</li>
        <li><strong>Status</strong> — Activ/Inactiv (toggle) și Validat/Nevalidat (badge).</li>
      </ul>

      <h2>Creare și editare</h2>
      <p>Formularul include:</p>
      <ul>
        <li><strong>Denumire</strong> — numele public afișat pe site (obligatoriu).</li>
        <li><strong>Date legale</strong> — Denumire legală, CIF/CUI, Sediu social, Reprezentant legal (nume și funcție). Acestea sunt necesare pentru semnarea DPA.</li>
        <li><strong>Tip organizație</strong> — categorie juridică.</li>
        <li><strong>Descriere</strong> — text <a href="/staff/documentatie/markdown">Markdown</a> afișat pe pagina publică a prietenului.</li>
        <li><strong>Logo</strong> — imagine afișată pe site și în liste.</li>
        <li><strong>Contact</strong> — persoană de contact, telefon și email.</li>
      </ul>

      <h3>Date legale blocate după DPA</h3>
      <p>
        Dacă prietenul a semnat DPA, datele legale sunt afișate doar în citire.
        Pentru a le edita, trebuie să confirmi că modificarea va invalida DPA-ul.
        Prietenul va trebui să re-semneze acordul.
      </p>

      <h2>Validare</h2>
      <p>Un prieten este considerat <strong>validat</strong> dacă:</p>
      <ol>
        <li>Toate câmpurile legale sunt completate (denumire legală, CIF, sediu, reprezentant).</li>
        <li>A semnat Acordul de Prelucrare a Datelor (DPA).</li>
      </ol>
      <p>
        Badge-ul <strong>Validat</strong> (albastru) sau <strong>Nevalidat</strong> (galben) apare în tabel lângă status.
      </p>

      <h2>Revocare DPA</h2>
      <p>
        Superadminii pot revoca DPA-ul unui prieten validat folosind butonul cu iconul de scut (🛡✕) din coloana de acțiuni.
        Revocarea resetează validarea și blochează accesul prietenului la datele participanților.
      </p>

      <h2>Impact validare</h2>
      <p>
        Consultă <a href="/staff/documentatie/dpa">documentația DPA</a> pentru detalii despre cum validarea afectează
        accesul prietenilor la datele participanților.
      </p>
    </DocLayout>
  );
}
